import { HexagonBorder } from 'app/assets/icons/HexagonBorder'
import React from 'react'
import {
    AirCond,
    Arachide,
    Avatar,
    Bag,
    Beef as OldBeef,
    Biking,
    Birthday,
    Burger as OldBurger,
    BurgerKare,
    CameraPlus,
    Card,
    Catalog,
    CcHand,
    CcHandLogo,
    Celery,
    Chicken as OldChicken,
    CircleAvatar,
    CircleBacon as OldCircleBacon,
    CircleBeef as OldCircleBeef,
    CircleChicken as OldCircleChicken,
    CircleColdDrink as OldCircleColdDrink,
    CircleCrown,
    CircleFish as OldCircleFish,
    CircleHotDrink as OldCircleHotDrink,
    CircleLock,
    CirclePencil,
    CirclePlus,
    CircleSalad as OldCircleSalad,
    CircleVeggie as OldCircleVeggie,
    ClickAndCollect,
    ColdDrink as OldColdDrink,
    CreditCard,
    Crown,
    Crustacean,
    Currently,
    Delices as OldDelices,
    Delivery,
    Drive,
    Egg,
    Facebook,
    Family,
    FidelityCard,
    FilledLock,
    Fish as OlfFish,
    GameArea,
    Gluten,
    Handicapped,
    HeartFamily,
    Hexagon,
    HotDrink as OldHotDrink,
    HotNews,
    Info,
    Instagram,
    Jobs,
    King as OldKing,
    KingBreakfast,
    KingDeal as OldKingDeal,
    Light,
    Lock,
    Lupine,
    Map,
    Menu as OldMenu,
    Milk,
    Mollusc,
    Moon,
    Mustard,
    Nitrate,
    Nut,
    Offers,
    Order,
    PaperNews,
    Parking,
    PreOrder,
    Question,
    Salad as OldSalad,
    Sauce as OldSauce,
    Search,
    Sesame,
    SmallSnacks,
    Snacks as OldSnacks,
    Soy,
    Store,
    TakeAway,
    Terrace,
    Ticket,
    TikTok,
    Twitter,
    Upload,
    Wifi,
    BagOnClick
} from 'app/assets/icons'

import {
    Bacon,
    BagKingJr as King,
    Beef,
    Burger,
    Chicken,
    ColdDrink,
    Deals as KingDeal,
    Fish,
    Fries as Snacks,
    HotDrink,
    KingBox,
    KingFusion as Delices,
    LittleMenu as Menu,
    Salad,
    Sauce,
    Veggie,
    Wrap,
    CircleBacon,
    CircleBeef,
    CircleChicken,
    CircleColdDrink,
    CircleFish,
    CircleHotDrink,
    CircleKingBox,
    CircleSalad,
    CircleVeggie,
    CircleWarningIcon
} from 'app-v2/assets/icons'

type Props = {
    code: string,
    color?: string,
    background?: string
}

export const Icon = (props: Props) => {
    const { code, ...otherProps } = props
    switch (code.toUpperCase()) {
        case 'ACCOUNT':
            return <Crown {...otherProps} />
        case 'AIR_COND':
            return <AirCond {...otherProps} />
        case 'ARACHIDE':
            return <Arachide {...otherProps} />
        case 'AVATAR':
            return <Avatar {...otherProps} />
        case 'BAG':
            return <Bag {...otherProps} />
        case 'BEEF':
            return <Beef {...otherProps} />
        case 'BIKING':
            return <Biking {...otherProps} />
        case 'BIRTHDAY':
            return <Birthday {...otherProps} />
        case 'BLAZON':
            return <Hexagon {...otherProps} />
        case 'BLAZON_BORDER':
            return <HexagonBorder {...otherProps} />
        case 'BREAKFAST':
            return <KingBreakfast {...otherProps} />
        case 'BURGERS':
            return <Burger {...otherProps} />
        case 'BURGER_KARE':
            return <BurgerKare {...otherProps} />
        case 'CAMERA_PLUS':
            return <CameraPlus {...otherProps} />
        case 'CARD':
            return <Card {...otherProps} />
        case 'CATALOG':
            return <Catalog {...otherProps} />
        case 'CC_HAND':
            return <BagOnClick {...otherProps} />
        case 'CC_HAND_LOGO':
            return <CcHandLogo {...otherProps} />
        case 'CELERI':
            return <Celery {...otherProps} />
        case 'CHICKEN':
            return <Chicken {...otherProps} />
        case 'CHILDS_MENU':
            return <King {...otherProps} />
        case 'CIRCLE_AVATAR':
            return <CircleAvatar {...otherProps} />
        case 'CIRCLE_WARNING':
            return <CircleWarningIcon {...otherProps} />
        case 'CIRCLE_MENU_BEEF':
        case 'CIRCLE_BEEF':
            return <CircleBeef {...otherProps} />
        case 'CIRCLE_MENU_CHICKEN':
        case 'CIRCLE_CHICKEN':
            return <CircleChicken {...otherProps} />
        case 'CIRCLE_COLD_DRINK':
            return <CircleColdDrink {...otherProps} />
        case 'CIRCLE_MENU_FISH':
        case 'CIRCLE_FISH':
            return <CircleFish {...otherProps} />
        case 'CIRCLE_KINGBOX':
            return <CircleKingBox {...otherProps} />
        case 'CIRCLE_HOT_DRINK':
            return <CircleHotDrink {...otherProps} />
        case 'CIRCLE_LOCK':
            return <CircleLock {...otherProps} />
        case 'CIRCLE_PENCIL':
            return <CirclePencil {...otherProps} />
        case 'CIRCLE_PLUS':
            return <CirclePlus {...otherProps} />
        case 'CIRCLE_SALAD':
            return <CircleSalad {...otherProps} />
        case 'CIRCLE_VEGGIE':
            return <CircleVeggie {...otherProps} />
        case 'CIRCLE_CROWN':
            return <CircleCrown {...otherProps} />
        case 'CLICK&COLLECT':
            return <ClickAndCollect {...otherProps} />
        case 'COLD_DRINKS':
        case 'DRINKS':
        case 'DRINKS_EDIT':
            return <ColdDrink {...otherProps} />
        case 'CRAB':
            return <Crustacean {...otherProps} />
        case 'CREDIT_CARD':
            return <CreditCard {...otherProps} />
        case 'CROWN':
            return <Crown {...otherProps} />
        case 'DELIVERY':
        case 'DELIVERY_DELIVEROO':
        case 'DELIVERY_UBEREATS':
            return <Delivery {...otherProps} />
        case 'DRIVE':
            return <Drive {...otherProps} />
        case 'EGG':
            return <Egg {...otherProps} />
        case 'FAMILY':
            return <Family {...otherProps} />
        case 'FACEBOOK':
            return <Facebook {...otherProps} />
        case 'FIDELITY_CARD':
            return <FidelityCard {...otherProps} />
        case 'FILLED_LOCK':
            return <FilledLock {...otherProps} />
        case 'FISH':
            return <Fish {...otherProps} />
        case 'FREE_WIFI':
            return <Wifi {...otherProps} />
        case 'GLUTEN':
            return <Gluten {...otherProps} />
        case 'HEART_FAMILY':
            return <HeartFamily {...otherProps} />
        case 'HOT_DRINKS':
            return <HotDrink {...otherProps} />
        case 'INFO':
            return <Info {...otherProps} />
        case 'INSTAGRAM':
            return <Instagram {...otherProps} />
        case 'JOBS':
            return <Jobs {...otherProps} />
        case 'KING_BREAKFAST':
            return <KingBreakfast {...otherProps} />
        case 'KING_DEAL':
            return <KingDeal {...otherProps} />
        case 'KINGDOM':
            return <Avatar {...otherProps} />
        case 'LEGAL':
            return <PaperNews {...otherProps} />
        case 'LIGHT':
            return <Light {...otherProps} />
        case 'LITTLE_PLEASURES':
            return <KingDeal {...otherProps} />
        case 'LOCK':
            return <Lock {...otherProps} />
        case 'LUPIN':
            return <Lupine {...otherProps} />
        case 'MENU':
            return <Menu {...otherProps} />
        case 'MILK':
            return <Milk {...otherProps} />
        case 'MUSTARD':
            return <Mustard {...otherProps} />
        case 'NEW':
            return <HotNews {...otherProps} />
        case 'NIGHT_OPENING':
            return <Moon {...otherProps} />
        case 'NO_BACON':
            return <CircleBacon {...otherProps} />
        case 'NOW':
            return <Currently {...otherProps} />
        case 'NUT':
            return <Nut {...otherProps} />
        case 'OFFERS':
            return <Offers {...otherProps} />
        case 'ORDER':
            return <Order {...otherProps} />
        case 'ORDERS':
            return <ClickAndCollect {...otherProps} />
        case 'PARKING':
            return <Parking {...otherProps} />
        case 'PLAYGROUND':
            return <GameArea {...otherProps} />
        case 'PRE_ORDER':
            return <PreOrder {...otherProps} />
        case 'PRM':
            return <Handicapped {...otherProps} />
        case 'QUESTION':
            return <Question {...otherProps} />
        case 'SALADS':
            return <Salad {...otherProps} />
        case 'SAUCE':
            return <Sauce {...otherProps} />
        case 'SEARCH':
            return <Search {...otherProps} />
        case 'SESAME':
            return <Sesame {...otherProps} />
        case 'SHELLFISH':
            return <Mollusc {...otherProps} />
        case 'SMALL_SNACKS':
            return <SmallSnacks {...otherProps} />
        case 'SNACKS':
            return <Snacks {...otherProps} />
        case 'SOJA':
            return <Soy {...otherProps} />
        case 'STORE':
            return <Store {...otherProps} />
        case 'STORES':
            return <Map {...otherProps} />
        case 'SULFITE':
            return <Nitrate {...otherProps} />
        case 'SWEETS':
            return <Delices {...otherProps} />
        case 'TERRACE':
            return <Terrace {...otherProps} />
        case 'TAKEAWAY':
            return <TakeAway {...otherProps} />
        case 'TICKET':
            return <Ticket {...otherProps} />
        case 'TIKTOK':
            return <TikTok {...otherProps} />
        case 'TWITTER':
            return <Twitter {...otherProps} />
        case 'UPLOAD':
            return <Upload {...otherProps} />
        case 'WRAPS':
            return <Wrap {...otherProps} />
        default:
            return null
    }
}
